module.exports = __webpack_public_path__ + "img/aParty_091123_D.9f5ddc5c.jpg";